import React from 'react'
import styled from 'styled-components'
import MediaQuery from 'react-responsive'
import {_L, useLocaleState} from '../../context/LocaleContext'

const ListContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-column-gap: 8px;
  grid-row-gap: 6px;
  justify-items: start;
  align-items: center;
  box-sizing: border-box;
  padding: 8px;
  background-color: white;
  border-radius: 6px;
  margin-bottom: 6px;
`

const RegisterButton = styled.button`
  background: #3395fe;
  color: #ffffff;
  height: 34px;
  font-size: 16px;
  font-weight: 400;
  padding: 6px;
  text-align: center;
  border-radius: 6px;
`

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 6px;
  margin-bottom: 8px;
  font-size: 14px;
  border: 1px solid lightgrey;
`

const StyledCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  color: #000000;
  border-bottom: 1px solid #f3f5fb;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  font-weight: 600;
  font-size: 16px;
`

const StyledCardLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: grey;
  padding-right: 8px;
  width: 80px;
`

const StyledCardRow = styled.div`
  display: flex;
  padding-left: 8px;
`

const KioskEquipmentCard = ({equipment, onClick}) => {
  const {eqId, blId, flId, rmId, eqStd} = equipment

  const localeState = useLocaleState()

  return (
    <StyledCard>
      <StyledCardHeader>
        <div>{eqId}</div>
        <RegisterButton onClick={() => onClick(equipment)}>
          {_L({key: 'Register', localeState})}
        </RegisterButton>
      </StyledCardHeader>
      <div style={{paddingTop: 8, paddingBottom: 8}}>
        <StyledCardRow>
          <StyledCardLabel>{_L({key: 'Type:', localeState})}</StyledCardLabel>
          <div>{eqStd}</div>
        </StyledCardRow>
        <StyledCardRow>
          <StyledCardLabel>
            {_L({key: 'Building:', localeState})}
          </StyledCardLabel>
          <div>{blId}</div>
        </StyledCardRow>
        <StyledCardRow>
          <StyledCardLabel>{_L({key: 'Floor:', localeState})}</StyledCardLabel>
          <div>{flId}</div>
        </StyledCardRow>
        <StyledCardRow>
          <StyledCardLabel>{_L({key: 'Room:', localeState})}</StyledCardLabel>
          <div>{rmId}</div>
        </StyledCardRow>
      </div>
    </StyledCard>
  )
}

const KioskEquipmentItem = ({equipment, onClick}) => {
  const {eqId, blId, flId, rmId, eqStd} = equipment

  const localeState = useLocaleState()

  return (
    <ListContainer>
      <div>{eqStd}</div>
      <div>{eqId}</div>
      <div>{blId}</div>
      <div>{flId}</div>
      <div>{rmId}</div>
      <div>
        <RegisterButton onClick={() => onClick(equipment)}>
          {_L({key: 'Register', localeState})}
        </RegisterButton>
      </div>
    </ListContainer>
  )
}

const KioskEquipment = ({equipment, onClick}) => {
  return (
    <MediaQuery minDeviceWidth={520}>
      {matches =>
        matches ? (
          <KioskEquipmentItem equipment={equipment} onClick={onClick} />
        ) : (
          <KioskEquipmentCard equipment={equipment} onClick={onClick} />
        )
      }
    </MediaQuery>
  )
}

export default KioskEquipment
